<template>
<v-app>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de la empresa
                  </h3>
                  <div class="wizard-desc">
                    Ingrese y busque Empresa asociada
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información del Usuario
                  </h3>
                  <div class="wizard-desc">
                    Configure datos personales
                  </div>
                </div>
              </div>
            </div>

            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/Map/Compass.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de Seguridad
                  </h3>
                  <div class="wizard-desc">
                    Configure credenciales
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <b-form class="form" @submit.stop.prevent="onSubmit">
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos la empresa
                  </h4>
                  <div class="form-group">
                      <div class="form-group">
                        <label>Empresa</label>
                        {{$v.form.rutEmpresa.$model}}
                        <v-autocomplete
                          v-model="$v.form.rutEmpresa.$model"
                          :items="companies"
                          item-text="nombre"
                          item-value="rutEmpresaCompleto"
                          cache-items
                          hide-no-data
                          hide-details
                          label="Escribe el nombre de la empresa"
                          solo-inverted
                        ></v-autocomplete>
                        <b-form-invalid-feedback id="input-rutEmpresa-live-feedback">
                          Empresa es requerido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <button :disabled="$v.form.rutEmpresa.$model==''"
                      class="btn btn-primary align-self-center"
                      data-wizard-type="action-next"
                    >
                      Continuar
                    </button>
                    <b-button v-b-modal.modal-1 class="ms-2 btn btn-light align-self-center">Nueva Empresa</b-button>
                </div>
                <!--end: Wizard Step 1-->
                <!--begin: Wizard Step 2-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos personales
                  </h4>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Rut Cliente</label>
                        <b-form-input
                          class="form-control"
                          id="example-input-1"
                          name="example-input-1"
                          v-model="$v.form.rutCliente.$model"
                          :state="validateState('rutCliente')"
                          aria-describedby="input-rut-live-feedback" autofocus
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-rut-live-feedback">
                          Rut es requerido y debe ser valido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Nombres</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-3"
                      name="example-input-3"
                      v-model="$v.form.nombres.$model"
                      :state="validateState('nombres')"
                      aria-describedby="input-3-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-3-live-feedback">
                      Nombre es requerido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="form-group">
                    <label>Apellidos</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-4"
                      name="example-input-4"
                      v-model="$v.form.apellidos.$model"
                      :state="validateState('apellidos')"
                      aria-describedby="input-4-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-4-live-feedback">
                      Apellidos es requerido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Teléfono</label>
                        <b-form-input
                          class="form-control"
                          type="tel"
                          id="telefono"
                          name="telefono"
                          v-model="$v.form.telefono.$model"
                          :state="validateState('telefono')"
                          aria-describedby="input-telefono-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-telefono-feedback">
                          Teléfono es requerido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                        class="form-control"
                        type="email"
                        id="example-input-5"
                        name="example-input-5"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                        aria-describedby="input-5-live-feedback"
                      ></b-form-input>

                      <b-form-invalid-feedback id="input-5-live-feedback">
                        Email es requerido.
                      </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>
                  <button 
                      class="btn btn-primary align-self-center"
                      data-wizard-type="action-next"
                    >
                      Continuar +
                    </button>
                   
                </div>
                <!--end: Wizard Step 2-->

                <!--begin: Wizard Step 3-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Configure Información de Acceso
                  </h4>
                  <div class="row">
                     <div class="col-xl-12">
                       <div class="alert alert-info">
                         La contraseña del usuario será creada y enviada al cliente a su correo electrónico.
                       </div>
                     </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Contraseña</label>
                        <b-form-input
                          class="form-control"
                          type="password"
                          id="example-input-1"
                          name="example-input-1"
                          v-model="$v.form.password.$model"
                          :state="validateState('password')"
                          aria-describedby="input-1-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-1-live-feedback">
                          Contraseña es requerida.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Confirme Conraseña</label>
                        <b-form-input
                        class="form-control"
                        type="password"
                        id="example-input-2"
                        name="example-input-2"
                        v-model="$v.form.passwordConfirm.$model"
                        :state="validateState('passwordConfirm')"
                        aria-describedby="input-2-live-feedback"
                      ></b-form-input>

                      <b-form-invalid-feedback id="input-2-live-feedback">
                        Confirmación Contraseña es requerida.
                      </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Cuenta Activada</label>
                         <v-switch v-model="switch1"></v-switch>
                        <span class="form-text text-muted"
                          > </span
                        >
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>
                  <button 
                      class="btn btn-primary align-self-center"
                      type="submit"
                    >
                      Continuar
                    </button>
                </div>
                <!--end: Wizard Step 3-->

                

               
              </b-form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
  <b-modal
      id="modal-1"
      ref="modal"
      title="Nueva Empresa"
      cancel-title="Cancelar"
      ok-title="Crear Empresa"
      cancel-variant="light"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Rut"
          label-for="name-input"
          invalid-feedback="Rut es obligatorio"
          :state="rutState"
        >
          <b-form-input
            @keyup="formatRut" 
            placeholder="1111111-1"  
            maxlength="12" 
            required="true" class="form-control"
            id="rut-input"
                        v-model="$v.form1.rut.$model"
                      :state="validateState2('rut')"
          ></b-form-input>
          <b-form-invalid-feedback id="rut-input-live-feedback">
             Error. Favor verificar
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Nombre"
          label-for="name-input"
          invalid-feedback="Nombre es obligatorio"
          :state="nameState"
        >
          <b-form-input
          class="text-uppercase"
            id="name-input"
            v-model="$v.form1.nombre.$model"
                      :state="validateState2('nombre')"
            required
          ></b-form-input>
          <b-form-invalid-feedback id="name-input-live-feedback">
             Error. Favor verificar
          </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>
</v-app>

</template>
<style lang="scss">
@import "~vuetify/dist/vuetify.css";

.theme--light.v-application {
  background: transparent !important;
}
.v-application code {
  box-shadow: none !important;
}
</style>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>

<script>

import { mapState } from "vuex";
import { GET_COMPANIES } from "@/core/services/store/company.module";
import { CREATE_CLIENT, CREATE_CLIENT_MASTER } from "@/core/services/store/client.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import { validationMixin } from "vuelidate";
import { formatRut, rutEsValido } from "@/core/validators/rut.js"

// import { email, minLength, required, sameAs } from "vuelidate/lib/validators";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "Wizard-2",
  data() {
    return {    
      rut: '',
      nameState: null,
      rutState:null,
      submittedNames: [],
      wizard:null,
      switch1: true,
      step:1,
       form: {
        rutEmpresa: "",
        rutCliente:"",
        nombres:"",
        apellidos:"",
        telefono:null,
        email:"",
        passwordConfirm: "",
        password: "",
        activo:true
      },
      form1: {
        rut: "",
        nombre:""
      },
    };
  },
  validations: {
    form: {
      rutEmpresa: {
      required,
       // rut
      },
      rutCliente: {
        required,
       // rut
      },
      nombres: {
        required,
        minLength: minLength(3)
      },
      apellidos: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      telefono: {
        required
      },
      password: {
        // required,
        // minLength: minLength(3)
      },
      passwordConfirm: {
        // required,
        // minLength: minLength(3),
        // sameAsPassword:sameAs('password')
      }
    },
    form1: {
      rut: {
        required,
        rutEsValido
      },
      nombre: {
        required,
       // rut
      }
    }
  },
  mounted() {
    
    this.getCompanies();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Wizard", route: "wizard-1" },
      { title: "Wizard-2" }
    ]);

    // Initialize form wizard
    this.wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    this.wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    this.wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    formatRut(){
      this.rut = formatRut(this.rut);
    },

    makeToast(append = false) {
      this.$bvToast.toast(`Hemos enviado la bienvenida y contraseña de acceso al cliente.`, {
        title: 'Cliente creado exitosamente',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    getCompanies(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_COMPANIES, params)
          .then(()=>{
            this.$Progress.finish()});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit: function() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return;
      }
      this.crearCuenta();
    },
    crearCuenta(){
      const rutEmpresa = this.$v.form.rutEmpresa.$model;
      const numeroDocumento = '';
      const rutCliente = this.$v.form.rutCliente.$model;
      const nombres = this.$v.form.nombres.$model;
      const apellidos = this.$v.form.apellidos.$model;
      const email = this.$v.form.email.$model;
      const telefono = parseInt(this.$v.form.telefono.$model);
      //const password = this.$v.formFull.password.$model;
      //const passwordConfirm = this.$v.formFull.passwordConfirm.$model;
      // set spinner to submit button
      //const submitButton = this.$refs["kt_register_signin_submit"];
      //submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      console.log({ rutEmpresa, numeroDocumento, rutCliente, nombres, apellidos, email, telefono, activo:this.switch1 })
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(CREATE_CLIENT, { rutEmpresa, numeroDocumento, rutCliente, nombres, apellidos, email, telefono, activo:this.switch1 })
          // go to which page after successfully login
          .then(() => this.makeToast());

        /*submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );*/
      }, 500);
    },

    validateState2(name) {
      const { $dirty, $error } = this.$v.form1[name];
      return $dirty ? !$error : null;
    },
      resetModal() {
        this.name = ''
        this.nameState = null
      },
      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.$v.form1.$touch();

        if (this.$v.form1.$anyError) {
          return;
        }
        this.handleSubmit()
      },
      handleSubmit() {
        const rut = this.$v.form1.rut.$model;
        const nombre = this.$v.form1.nombre.$model;
        this.$store
          .dispatch(CREATE_CLIENT_MASTER, { rut:rut, nombre: nombre.toUpperCase(), activa: true })
          // go to which page after successfully login
          .then(() => {
            this.$bvToast.toast(`La empresa se ha creado correctamente. Ya puedes seleccionarla desde el listado.`, {
                title: 'Empresa creada exitosamente',
                autoHideDelay: 5000,
                variant: "success",
                toaster:"b-toaster-top-right",
                appendToast: false
              });
              this.getCompanies();
                this.$v.form.rutEmpresa.$model = rut;
                this.$bvModal.hide('modal-1')
          }).catch((e)=> {
            this.$bvToast.toast(`${e.data.errors[0]}`, {
                title: 'Error',
                autoHideDelay: 5000,
                variant: "error",
                toaster:"b-toaster-top-right",
                appendToast: false
              })
          });

        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing')
        })
      }
  },
  computed: {
    ...mapState({
      errors: state => state.errors,
      companies: state => state.company.companies,
    })
  }
};
</script>

<style>
.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot {
   background: #fff !important;
   color:#000  !important;
}
.theme--light.v-text-field--solo-inverted > .v-input__control > .v-input__slot {
    background: #fff !important;
   color:#000  !important;
}
.theme--light.v-text-field--solo-inverted.v-input--is-focused > .v-input__control > .v-input__slot input {
    color:#000  !important;
}
</style>